import * as React from 'react';
import { Tree, Input } from 'antd';

import { FormItem } from '../../../../components/Form';
import PaymentMethods from '../../../../components/Query/PaymentMethods';
import CountryTree from '../../../../components/Others/CountryTree';
import { getPriceWithout } from '../../../../helpers/Prices/getPrice';

export interface IPaymentMethodsColProps {
  domain: string;
  currency: GQL.ICurrency;
  deliveryMethod: GQL.IDeliveryMethod;
  selectedPaymentMethodsIds: string[];
  selectedCountryIds: string[];
  currentLanguage: string;
  onChange: Function;
}

export default class PaymentMethodsCol extends React.Component<IPaymentMethodsColProps> {

  constructor(props: IPaymentMethodsColProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { selectedPaymentMethodsIds, selectedCountryIds, currency } = this.props;

    return (
      <>
        <FormItem label={'Allowed payment methods'}>
          <PaymentMethods
            domain={this.props.domain}
          >
            {({ paymentMethods }: any) => {
              if (paymentMethods.loading) {
                return <span>Loading...</span>;
              }

              return (
                <Tree
                  onCheck={(checkedKeys: any) => this.onChange('selectedPaymentMethodsIds', checkedKeys.checked)}
                  onSelect={(checkedKeys: any) => this.onChange('selectedPaymentMethodsIds', checkedKeys)}
                  selectedKeys={selectedPaymentMethodsIds}
                  checkedKeys={selectedPaymentMethodsIds}
                  multiple={true}
                  checkable={true}
                  checkStrictly={true}
                  treeData={paymentMethods.paymentMethods.map((p: GQL.IPaymentMethod) => {
                    p.key = p.id
                    return p;
                  })}
                />
              );
            }}
          </PaymentMethods>
        </FormItem>

        <FormItem label={'Allowed for country'}>
          <CountryTree
            name={'selectedCountryIds'}
            value={selectedCountryIds}
            onChange={(e: any, countries: GQL.ICountry[]) => this.onChange('selectedCountryIds', e.target.value)}
          />
        </FormItem>

        <FormItem label={'Pohoda IDS'}>
          <Input
            style={{width: '75%'}}
            name={'PohodaIDS'}
            placeholder="Pohoda IDS"
            defaultValue={this.props.deliveryMethod.PohodaIDS || undefined}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        {this.props.deliveryMethod.insurance && Array.isArray(this.props.deliveryMethod.insuranceLimits)
          ? this.props.deliveryMethod.insuranceLimits.map((limit, i) => (
            <FormItem key={`insurance-limit-${i}`} label={`Insurance ${getPriceWithout(limit.prices, currency) || '-'} ${currency.value} Pohoda IDS`}>
              {console.log('L', i, limit)}
              <Input
                style={{width: '75%'}}
                name={`#PohodaIDS-${i}`}
                placeholder="Pohoda IDS"
                defaultValue={limit.PohodaIDS || undefined}
                onChange={e => {
                  const insuranceLimits = this.props.deliveryMethod.insuranceLimits;
                  if (Array.isArray(insuranceLimits) && insuranceLimits[i]) {
                    insuranceLimits[i].PohodaIDS = e.target.value;
                    this.props.onChange({ target: {name: 'insuranceLimits', value: insuranceLimits}});
                  }
                }}
              />
            </FormItem>
          ))
          : ''}
      </>
    );
  }
      
  private onChange(name: string, value: any) {
    this.props.onChange({
      target: {
        name,
        value
      }
    });
  }

}


// WEBPACK FOOTER //
// ./src/scenes/DeliveryMethods/DeliveryMethodDetail/components/PaymentMethods.tsx